import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import {Grid} from 'react-bootstrap';
import Breadcrumbs from 'system/breadcrumbs';
import List from '../../list';
import {Wrapper} from 'system/wrapper';

import documents from 'images/information-center/documents.svg';
import projects from 'images/information-center/projects.svg';
import reform from 'images/information-center/reform.svg';
import procurement from 'images/information-center/procurement.svg';
import corruption from 'images/information-center/corruption.svg';
import faq from 'images/information-center/faq.svg';
import communities from 'images/information-center/communities.svg';

class MainInformation extends Component {
  render() {
    return (
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/">Інфоцентр</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Інфоцентр</h2>
            <List>
              <li>
                <Link to="/infocenter/documents">
                  <div>
                    <img src={documents} alt="Лікарі"/>
                  </div>
                  <h3>Нормативно-правова база</h3>
                </Link>
              </li>

              <li>
                <Link to="/infocenter/projects">
                  <div>
                    <img src={projects} alt="Лікарі"/>
                  </div>
                  <h3>Проекти та програми</h3>
                </Link>
              </li>

              <li>
                <Link to="/infocenter/reforms">
                  <div>
                    <img src={reform} alt="Лікарі"/>
                  </div>
                  <h3>Медична реформа</h3>
                </Link>
              </li>

              <li>
                <Link to="/infocenter/procurements">
                  <div>
                    <img src={procurement} alt="Лікарі"/>
                  </div>
                  <h3>Державні закупівлі </h3>
                </Link>
              </li>

              <li>
                <Link to="/infocenter/corruption">
                  <div>
                    <img src={corruption} alt="Лікарі"/>
                  </div>
                  <h3>Боротьба з корупцією</h3>
                </Link>
              </li>

              <li>
                <Link to="/infocenter/faq">
                  <div>
                    <img src={faq} alt="Лікарі"/>
                  </div>
                  <h3>Часті питання та відповіді</h3>
                </Link>
              </li>

              <li>
                <Link to="/infocenter/communities">
                  <div>
                    <img src={communities} alt="Лікарі"/>
                  </div>
                  <h3>Громадські організації</h3>
                </Link>
              </li>
            </List>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default MainInformation;



// WEBPACK FOOTER //
// ./src/system/information-center/main/index.js